import Center from "../../assets/images/product/facadeSilicate/center.webp";
import Left from "../../assets/images/product/facadeSilicate/left.webp";
import FacadeSilicate from "../../assets/images/products/facadeSilicate.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const facadeSilicate = {
  category: [categoriesOfPaints.facade],
  path: "festek_facade_silicate",
  name: "FESTEK-FACADE SILICATE",
  header: "Краска фасадная акриловая «FESTEK-FACADE SILICATE»",
  link: "https://drive.google.com/file/d/1_CW_gQ4xf1TCY1xVtiavX8ImwArkkt95/view?usp=sharing",
  purchase: [
    {
      price: "130,00",
      amount: "15 кг",
    },
  ],
  productsPage: {
    title: "Фасадная «FESTEK-FACADE SILICATE»",
    text: "Силикатная краска с повышенной паропроницаемостью. Эффективная защита фасада от негативных атмосферных явлений",
  },
  images: {
    products: FacadeSilicate,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это силикатная краска, которая обеспечивает повышенную адгезию и превосходную укрывистость покрытия. Благодаря входящему в состав жидкому калийному стеклу, краска глубоко проникает и прочно соединяется с поверхностью, что образует устойчиво покрытие к воздействию вредных факторов городской среды (газы, выхлопы), не стимулирует развитие микроорганизмов, плесени, грибка.",
        label: "FESTEK «FAСADE SILICATE»",
      },

      properties: {
        value: [
          "Стойкое к воздействию климатических факторов.",
          "Высокая адгезия к основанию и укрывистость.",
          "Обладает высокой светостойкостью.",
          "Образованное покрытие устойчиво к разрушающему воздействию атмосферных осадков, перепадов температур",
          "Образует «дышащее» покрытие с низким водопоглощением.",
          "Высокие диффузионные характеристики краски способствуют прохождению водяного пара из конструкций, уменьшая риск промерзания, что обеспечивает долговечность поверхности.",
          "Имеет насыщенный белый оттенок.",
        ],
        label: "Преимущество",
        note: [
          "Подходит для отделки поверхностей, от которых требуется высокая паропроницаемость.",
          "*Прогнозируемый срок службы покрытия при соблюдении технологии нанесения в комплексе с грунтовками – не менее 8 лет.",
        ],
      },

      consumption: {
        value:
          "На двухслойное покрытие – 350 - 400 г/м2. Зависит от пористости поверхности, применяемого оборудования, квалификации персонала, погодных условий. При окрашивании фактурных поверхностей (типа: шуба, барашек, короед и т.п.) расход краски увеличивается в 1,5 раза.",
        label: "Расход",
      },

      package: {
        value: "11 литров – 15 килограмм; 20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Бетонные, кирпичные, оштукатуренные и другие минеральные основания, старые и свежеоштукатуренные поверхности (известково-цементные, силикатные, известковые, цементные и цементно-известковые штукатурки), минеральные теплоизоляционные штукатурки, а также поверхности из силикатного кирпича, натурального камня и других материалов.",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          "Для получения качественного покрытия и снижения расхода краски поверхность обработать грунтовкой «Festek-Grunt» для глубокого проникновения или «Festek-MaxiGrunt», исходя из рекомендаций по применению. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %",
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Белый + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Водный раствор силиката калия, водная дисперсия акриловых сополимеров, пигменты, наполнители, силиконовая добавка, функциональные добавки, вода.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          "Перед применением поверхность очистить от пыли, грязи, разделительных жидкостей, меловых, известковых, непрочно держащихся и несовместимых покрытий (масляные, алкидные, полимерные и др. ЛКМ. При наличии биопоражений и высолов, удалить их механически или при помощи моек высокого давления, и при необходимости обработать специальными составами. Старые покрытия на основе дисперсионных красок удалить без остатка. Не окрашивать штукатурки на основе силиконовых и синтетических смол. Деревянные лакированные, стеклянные, металлические, керамические поверхности укрыть во избежание попадания на них краски, в случае их загрязнения – немедленно промыть водой. Новые бетонные поверхности окрашивать не ранее, чем через 28 дней, оштукатуренные – не ранее, чем через 7 дней после их естественного высыхания (или в соответствии с рекомендациями производителя).",
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value:
          "Работы проводить при температуре окружающего воздуха, краски и окрашиваемой поверхности не ниже 10 °С и не выше 25 °С. Не допускается нанесение при неблагоприятных погодных условиях (дождь, туман, выпадение росы, сильный ветер более 10 м/с). Не наносить краску на сильно нагретую поверхность, находящуюся под прямыми солнечными лучами. При проведении окрасочных работ влажность основания должна быть не более 8 %, влажность воздуха – не более 80 %. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %. Перед применением краску тщательно перемешать и наносить на поверхность: •\u00A0Кистью; •\u00A0Валиком; •\u00A0Пневматическим или безвоздушным методом распыления; Упаковку с частично использованным материалом тщательно закрыть, а ее содержимое использовать в наиболее короткий срок. Краска одного цвета, но различных партий может незначительно отличаться по тону. Для исключения разнооттеночности получаемого покрытия следует выбирать краску одной партии или смешивать необходимое количество материала различных партий в отдельной емкости. После работы инструмент, пятна отмыть теплой водой с мылом до высыхания краски.",
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Промежуточная сушка каждого слоя в течение 4 ч при температуре (20 ± 2) °С. При более низкой температуре и (или) повышенной влажности время высыхания может увеличиваться до 24 ч.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          'При нанесении краскопультом (безвоздушное) рекомендуются след. параметры: угол распыления 60°, диаметр сопла 0,53-0,58 мм (0,021"-0,023" дюйма), Давление 175-180 bar.',
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Массовая доля нелетучих веществ, %",
        value: "52 - 62",
      },
      {
        qualityIndicators: "Показатель концентрации ионов водорода, рН",
        value: "10,0 - 13,0",
      },
      { qualityIndicators: "Степень перетира, мкм, не более", value: "70" },
      {
        qualityIndicators:
          "Время высыхания до степени 3 при температуре (20 ± 2) °С, ч, не более",
        value: "1",
      },
      {
        qualityIndicators:
          "Условная светостойкость покрытия за 24 ч (изменение коэффициента диффузного отражения), за 24 ч, не более",
        value: "5",
      },
      {
        qualityIndicators: "Адгезия покрытия к основанию, МПа, не менее",
        value: "2,0",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к статическому воздействию воды при температуре (20 ± 2) °С, ч, не менее",
        value: "48",
      },
      {
        qualityIndicators:
          "Коэффициент паропроницаемости, мг/(м ч Па), не менее",
        value: "0,020",
      },
      {
        qualityIndicators: "Морозостойкость покрытия, циклы, не менее",
        value: "50",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к воздействию климатических факторов, циклы, не менее",
        value: "100",
      },
      {
        qualityIndicators:
          "Срок службы покрытия, лет, не менее в условиях эксплуатации У1, тип атмосферы II:",
        value: "8",
      },
    ],
  },
};
